<template>
  <div>
    <v-layout class="pb-8">
      <v-flex class="pr-30" xs6>
        <cover-field-vertical v-model="form.welcomeBackground" class="pb-4" :cropper="false" />
      </v-flex>
      <v-flex xs6>
        <v-layout column>
          <text-field
            v-model.trim="form.welcomeTitle"
            label="Welcome title"
            autofocus
          />
          <textarea-field
            v-model.trim="form.welcomeSubtitle"
            class="pb-1"
            label="Welcome subtitle"
          />
        </v-layout>
      </v-flex>
    </v-layout>
    <v-flex>
      <v-combobox
        v-model="form.interests"
        label="Interests"
        multiple
        chips
        deletable-chips
      />
    </v-flex>
    <v-flex>
      <text-field
        v-model="form.aboutUs"
        :validator="vs.form.aboutUs"
        label="About us"
      />
    </v-flex>
    <v-flex>
      <text-field
        v-model="form.partners"
        :validator="vs.form.partners"
        label="Our partners"
      />
    </v-flex>
    <v-layout style="text-align: center;">
      <v-flex>
        <color-picker-field v-model="form.primaryColor" label="Primary color" />
      </v-flex>
      <v-flex>
        <color-picker-field v-model="form.secondaryColor" :on-change="onSecondaryChange" label="Secondary color" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'event-conference-data-form',
  props: {
    initialValues: {
      type: Object,
      default: () => ({}),
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues || {},
    }
  },
  watch: {
    form: {
      handler(val){
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  methods: {
    onSecondaryChange({ hex }) {
      if (!this.form.primaryColor) return this.form.primaryColor = hex

      this.form.secondaryColor = hex
    },
  },
}
</script>

<style>

</style>
